import { ADDRESS_CLASSIFICATION, ADDRESS_ERRORS } from '../constants';
import { isClassificationValid } from './validators.utils';

const ERROR = ADDRESS_ERRORS.COMMERCIAL_FROM;
const CLASSIFICATION = ADDRESS_CLASSIFICATION.COMMERCIAL;
const isCommercialValid = isClassificationValid(CLASSIFICATION);

export function AddressCommercialFromValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link(scope, element, attrs, ctrl) {
      ctrl.$validators[ERROR] = (modelValue, viewValue) => {
        const value = modelValue || viewValue || {};
        return isCommercialValid(value);
      };
    },
  };
}
